<div class="row">
  <div class="col-md-12 mb-3">
    <div class="card p-3 shadow-sm">
      <h1 class="head1">Projects</h1>
      <div class="row mb-3">
        <div class="col-md-12">
          <div class="float-start">
            <label for="inputPassword6" class="col-form-label">Search By</label>
          </div>
          <div class="float-start ms-2">
            <input
              type="text"
              class="form-control"
              name="project_name"
              [(ngModel)]="filter.project_name"
              placeholder="Project Name"
              (keyup.enter)="searchByFilter()"
            />
          </div>
          <div class="float-start ms-2">
            <button
              class="btn btn-primary-sa btn-sm"
              (click)="searchByFilter()"
            >
              Search
            </button>
          </div>
          <div class="float-end ms-2">
            <button class="btn btn-primary-sa btn-sm" (click)="exportProject()">
              Export
            </button>
          </div>
          <div class="float-end ms-2">
            <a routerLink="/project/add" class="btn btn-primary-sa btn-sm"
              >Add Project</a
            >
          </div>
        </div>
      </div>
      <div class="table-scroll">
        <table width="100%" class="table table-striped">
          <thead>
            <tr>
              <th>Sr No</th>
              <th class="cursor-pointer" (click)="sortProject('name')">
                <span class="text-nowrap">
                  Name
                  <i
                    class="fas user-select-none"
                    [ngClass]="{
                      'fa-sort-up':
                        filter.sort_column === 'name' &&
                        filter.sort_order === 'ASC',
                      'fa-sort-down':
                        filter.sort_column === 'name' &&
                        filter.sort_order === 'DESC',
                      'fa-sort': filter.sort_column !== 'name'
                    }"
                  ></i>
                </span>
              </th>
              <th class="cursor-pointer" (click)="sortProject('full_name')">
                <span class="text-nowrap">
                  Project Admin
                  <i
                    class="fas user-select-none"
                    [ngClass]="{
                      'fa-sort-up':
                        filter.sort_column === 'full_name' &&
                        filter.sort_order === 'ASC',
                      'fa-sort-down':
                        filter.sort_column === 'full_name' &&
                        filter.sort_order === 'DESC',
                      'fa-sort': filter.sort_column !== 'full_name'
                    }"
                  ></i>
                </span>
              </th>
              <th>Email</th>
              <th>Ph. Number</th>
              <th class="cursor-pointer" (click)="sortProject('created_on')">
                <span class="text-nowrap">
                  Created Date
                  <i
                    class="fas user-select-none"
                    [ngClass]="{
                      'fa-sort-up':
                        filter.sort_column === 'created_on' &&
                        filter.sort_order === 'ASC',
                      'fa-sort-down':
                        filter.sort_column === 'created_on' &&
                        filter.sort_order === 'DESC',
                      'fa-sort': filter.sort_column !== 'created_on'
                    }"
                  ></i>
                </span>
              </th>
              <th>Devices</th>
              <th>Users</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let project of projects
                  | paginate
                    : {
                        itemsPerPage: filter.limit,
                        currentPage: filter.page,
                        totalItems: totalRecords
                      };
                index as i
              "
            >
              <td>{{ (filter.page - 1) * filter.limit + i + 1 }}</td>
              <td>
                <a
                  class="hyper-link"
                  href="javascript:;"
                  (click)="switchProject(project.id, project.name)"
                  >{{ project.name }}</a
                >
              </td>
              <td>{{ project.full_name }}</td>
              <td>
                <a href="javascript:;" class="email-link">{{
                  project.email
                }}</a>
              </td>
              <td>{{ formatContactNumber(project.phone_no.toString()) }}</td>
              <td>{{ project.created_on | date : "dd-MM-yyyy HH:mm:ss" }}</td>
              <td>{{ project.total_devices }}</td>
              <td>{{ project.total_users }}</td>
              <td>
                <div class="action-btn-table">
                  <a [routerLink]="['/project', project.id, 'edit']"
                    ><i class="fas fa-edit"></i
                  ></a>
                  <a href="javascript:;" (click)="confirmDelete(project.id)"
                    ><i class="fa-solid fa-trash-can text-danger"></i
                  ></a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <nav aria-label="Page navigation" class="pagenav-sa">
        <pagination-controls
          (pageChange)="pageChangeEvent($event)"
        ></pagination-controls>
      </nav>
    </div>
  </div>
</div>
